import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './apiDropdown.css';

import zapier_icon from '../../../assets/images/clay/lightning-clay.png';
import startup_icon from '../../../assets/images/clay/hammer-clay.png';
import enterprise_icon from '../../../assets/images/clay/dashboard-clay.png';


import api_docs from '../../../assets/images/api/api_example_view.png';

const ApiDropdown = () => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close the dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleClick = () => {
    setOpen((prev) => !prev);
  };

  return (
    <li className="unauthn-product-dropdown" ref={dropdownRef}>
      <button onClick={handleClick} className="unauthn-product-dropdown-toggle">
        API Solutions{' '}
        <span className={`unauthn-dropdown-arrow ${open ? 'open' : ''}`}>
          &#x25BC;
        </span>
      </button>
      <div className={`unauthn-product-dropdown-menu ${open ? 'open' : ''}`}>
        {/* LEFT COLUMN: BY BUSINESS */}
        <div className="unauthn-dropdown-column unauthn-dropdown-column-left dapi-left-stack">
          <h4 className="unauthn-dropdown-heading">By Business</h4>
          <div className="unauthn-features-grid">
              {/* Startup tile */}
              <Link
                to="/startup"
                className="unauthn-feature-tile"
                style={{ textDecoration: 'none' }}
                onClick={() => setOpen(false)}
              >
                <img src={startup_icon} alt="Icon" className="unauthn-feature-icon" />
                <div>
                  <h5 className="unauthn-feature-title">Startup</h5>
                  <p className="unauthn-feature-description">
                    Launch video processing quickly without expanding your team.
                  </p>
                </div>
              </Link>

              {/* Zapier tile */}
              <Link
                to="/zapier"
                className="unauthn-feature-tile"
                style={{ textDecoration: 'none' }}
                onClick={() => setOpen(false)}
              >
                <img src={zapier_icon} alt="Zapier Icon" className="unauthn-feature-icon" />
                <div>
                  <h5 className="unauthn-feature-title">Zapier</h5>
                  <p className="unauthn-feature-description">
                    Automate video workflows by connecting Bumpups to 8,000+ apps—no code required.
                  </p>
                </div>
              </Link>

              {/* Enterprise tile */}
              <Link
                to="/enterprise"
                className="unauthn-feature-tile"
                style={{ textDecoration: 'none' }}
                onClick={() => setOpen(false)}
              >
                <img src={enterprise_icon} alt="Icon" className="unauthn-feature-icon" />
                <div>
                  <h5 className="unauthn-feature-title">Enterprise</h5>
                  <p className="unauthn-feature-description">
                    Build the data foundation for any video workflow.
                  </p>
                </div>
              </Link>
            </div>
        </div>
        {/* RIGHT COLUMN: CUSTOMER SOLUTIONS */}
        <div className="unauthn-dropdown-column dapi-dropdown-column-right">
          <h4 className="unauthn-dropdown-heading">Customer Solutions</h4>
          <div className="dapi-solutions-list">
            <a
              href="https://docs.bumpups.com/docs/getting-started"
              target="_blank"
              rel="noopener noreferrer"
              className="dapi-solution-tile"
            >
              <h5 className="dapi-solution-title">Bumpups Documentation</h5>
              <p className="dapi-solution-description">
                Explore our API and integrate an AI Video model.
              </p>
              <img
                src={api_docs}
                alt="Customer branding"
                className="dapi-solution-image"
              />
            </a>
          </div>
        </div>
      </div>
    </li>
  );
};

export default ApiDropdown;
